import React from 'react';
import SaralLoader from '../../images/saral-loader.gif';

const SaralLoaderImage = ({ width = '80.5' }) => {
  return (
    <img className="saral-loader-img" alt="" src={SaralLoader} width={width} />
  );
};

export default SaralLoaderImage;
